'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronsUpDown } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';
import { dataFiles } from './_data';
export function DataRoom() {
  const $ = _c(10);
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setOpen(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><p className="text-xs font-black tracking-[0.3em] text-[#8a3f31] uppercase">Data room</p><h2 className="mt-1 font-sans text-3xl font-semibold sm:text-4xl">Discovery is open. Pull the CSVs.</h2></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = open ? "Hide" : "Expand";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronsUpDown className="size-4" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <button type="button" onClick={t0} className="flex w-full items-center justify-between gap-6 border border-[#24122f] bg-[#f7f0e6] px-5 py-4 text-left transition hover:bg-[#ede4d2]">{t1}<span className="flex shrink-0 items-center gap-2 border border-[#24122f] bg-[#24122f] px-3 py-2 text-xs font-black text-white uppercase">{t2}{t3}</span></button>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== open) {
    t5 = open && <div className="mt-6"><p className="mb-6 max-w-3xl text-base leading-7 font-semibold text-[#5f5364]">Every number on this page traces back to a public CSV below. Raw API cache stays local, but the appendix has the tables and the Python that built them. Bring your own grievance.</p><div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">{dataFiles.map(_temp2)}</div><Link href="/fantasy/data/README.md" className="mt-6 inline-flex border border-[#24122f] bg-[#24122f] px-4 py-3 text-sm font-black text-white uppercase transition hover:bg-[#4f6f3b]">Open full data README</Link></div>;
    $[5] = open;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <section className="fantasy-reveal border-y border-[#24122f] bg-[#fffaf1]"><div className="mx-auto max-w-7xl px-5 py-10 sm:px-8">{t4}{t5}</div></section>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp2(file) {
  return <Link key={file.href} href={file.href} className="group border border-[#d7c9b7] bg-[#f7f0e6] p-5 transition hover:-translate-y-1 hover:shadow-[7px_7px_0_#24122f]"><div className="flex items-start justify-between gap-4"><h3 className="font-sans text-2xl font-semibold">{file.label}</h3><span className="shrink-0 border border-[#24122f] bg-[#24122f] px-2 py-1 text-xs font-black text-white uppercase">{file.rows}</span></div><p className="mt-3 text-sm leading-6 font-semibold text-[#514458]">{file.detail}</p><p className="mt-5 text-xs font-black text-[#8a3f31] uppercase group-hover:text-[#4b8065]">Open file</p></Link>;
}
function _temp(v) {
  return !v;
}